<div class="offerwrapper acvis-elevation" (dragover)="dragOver($event)" (drop)="dropp($event)">
    <div class="offerheader">
        <span multilang class="offerheadertext"><b>Angebot Nr. {{index()}}</b> {{datas?.productType}}</span>
        <ng-container *ngIf="currentCustomer?.asPartner">
            <div class="actions">
                <mat-icon class="rmico mr3" (click)="openSetComment()" matTooltip="Extra info">
                    comment
                </mat-icon>
                <button [draggable]="true" class="drg mr3" matTooltip="Position ändern"
                    (dragstart)="dragStart($event, index())">
                    <svg _ngcontent-soh-c164="" width="24px" fill="currentColor" viewBox="0 0 24 24">
                        <path _ngcontent-soh-c164=""
                            d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                        </path>
                        <path _ngcontent-soh-c164="" d="M0 0h24v24H0z" fill="none"></path>
                    </svg>
                </button>
                <mat-icon class="rmico" (click)="removeFromListF()" matTooltip="Angebot löchen">
                    cancel
                </mat-icon>
            </div>
        </ng-container>
    </div>
    <div class="offerbody">
        <div class="offerimgwrapper">
            <ng-container *ngIf="showImmages">
                <imageslider (clickOnImg)="openImageModal($event)" [showcounter]="false" [current]="0" [data]="images"
                    class="offerimg">
                </imageslider>
            </ng-container>
            <div class="bookingcardheader">
                <div class="hotelnamewrapper" style="width: 100%;">
                    @if(ferienHauser?.originalTitle?.length > 0) {
                    <span multilang class="bold ellipsis" style="width: 95%;">{{ferienHauser?.originalTitle}}</span>
                    } @else {
                    <span multilang class="bold ellipsis" style="width: 95%;">{{ferienHauser?.title}}</span>
                    }
                    <span multilang class="locationsize">
                        {{ferienHauser?.location?.name}}
                    </span>
                </div>
            </div>
        </div>

        <div class="offerOperator" [style.background-color]="online()?.length > 0 ? '#ace59f': ''">
            <img src="../../../../assets/images/hometogo.svg" class="lazyload" height="24px" alt="hometogo">
            <span multilang style="font-weight: 500;">hometogo</span>
        </div>
        <div class="offerschedule">
            <mat-icon class="unsetico">event</mat-icon>
            <span multilang class="offerscheduletext">
                <b>{{(datas?.duration | number:'1.0-0') + (datas?.duration === '1' ? ' Nacht' : ' Nächte')}}</b>
                {{datas?.arrival | date:'dd.MM.yyyy'}} - {{endtDate | date:'dd.MM.yyyy'}}
            </span>
        </div>
        <div class="offerinfos">
            <div class="infobody">
                <div class="offerinfodet">
                    <mat-icon class="infoc">bedroom_child</mat-icon>
                    <span multilang style="margin-left: .3rem;word-break: break-all;">Schlafzimmer
                        {{ferienHauser?.bedrooms}}</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">group</mat-icon>
                    <span multilang style="margin-left: .3rem;">MaxPers. {{ferienHauser?.guests}}</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">pets</mat-icon>
                    <span multilang *ngIf="ferienHauser?.petFriendly" style="margin-left: .3rem;">Haustier
                        erlaubt</span>
                    <span multilang *ngIf="!ferienHauser?.petFriendly" style="margin-left: .3rem;">Haustier nicht
                        erlaubt</span>
                </div>
                <div class="offerinfodet">
                    <mat-icon class="infoc">aspect_ratio</mat-icon>
                    <span multilang style="margin-left: .3rem;">{{ferienHauser?.size}} m²</span>
                </div>
            </div>
            <button class="offerinfodet" (click)="openDetail()">
                <span multilang class="minbtn noselect" matRipple>Mehr Details</span>
            </button>
        </div>
        <div class="offerprice">
            <span multilang>
                <span multilang>Erwachsene : {{datas?.adults}}</span>
                <span multilang style="margin-left: .5rem;" *ngIf="datas?.children > 0">Kinder :
                    {{datas?.children}}</span>
            </span>
            <div class="offerpriceTotal">
                <span multilang>Gesamtpreis:</span>
                <span multilang class="prccolor">{{ferienHauser?.price?.total | number:'1.2-2'}} EUR</span>
            </div>
        </div>
        <button class="mhrd" (click)="gotoBuchen();">
            <div class="noselect bookingbtn">
                Buchen
            </div>
        </button>
    </div>
</div>

<ng-container *ngIf="showDetail">
    <clever-offerpackdetailmodal (triggerCloseModal)="closeModal($event)" [cmpRef]="component">
    </clever-offerpackdetailmodal>
</ng-container>